<template>
  <div>
    <el-tabs value="tab_pannel" type="border-card" v-model="activeName">
      <el-tab-pane label="保司管理" name="tab_1">

        <el-form ref="form" :model="formQuery" inline size="mini">

          <el-form-item label="保司ID：">
            <el-input v-model="formQuery.baosiId"></el-input>
          </el-form-item>

          <el-form-item label="保司名字：">
            <el-input v-model="formQuery.baosiName"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click.native.prevent="()=>{formVisible=true,isEdit = false;}">添加保司
            </el-button>

            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>


        <el-table :data="List" size="mini">
          <el-table-column type="expand">
            <template v-slot:="props">
              <vue-json-editor v-model="props.row" :showBtns="true"></vue-json-editor>
            </template>
          </el-table-column>
          <el-table-column label="保司ID" prop="_id" width="200"/>
          <el-table-column label="保司名字" prop="name" width="200"/>
          <el-table-column label="状态" prop="state" width="80">
            <template v-slot:="scope">
              <el-tag :type="getActiveStateTagInfo(scope.row.state).tag">{{ getActiveStateTagInfo(scope.row.state).label }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="销售主体" prop="saleEntity" width="100" :formatter="getSaleEntity"/>
          <el-table-column label="保司电话" prop="phone" width="150"/>
          <el-table-column label="操作" width="400">
            <template v-slot:="scope">
              <el-button style="margin-left: 10px;"
                         size="mini"
                         @click="handleEditVisble(scope.$index, scope.row)">编辑
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="warning"
                         @click="handleChangeState(1, scope.row)">冻结
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="warning"
                         @click="handleChangeState(2, scope.row)">下架
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         @click="handleChangeState(0, scope.row)">还原
              </el-button>
              <el-button style="margin-left: 10px;"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>


            </template>
          </el-table-column>
        </el-table>
        <Pagination ref="pagination" @change="onPageChange"></Pagination>
      </el-tab-pane>


    </el-tabs>


    <el-dialog title="保司信息" :visible.sync="formVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" size="mini">

        <el-form-item label="保司ID：">
          <el-input v-model="form._id"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="保司服务ID：">
          <el-input v-model="form.realId"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="所属主体：">
          <SaleEntity
              :saleEntity="form.saleEntity"
              @update:saleEntity="val => form.saleEntity = val"/>
        </el-form-item>

        <el-form-item label="保司名字：">
          <el-input v-model="form.name"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="保司电话：">
          <el-input v-model="form.phone"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="保司信息：">
          <el-input v-model="form.info"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="extra：">
          <vue-json-editor v-model="form.extra" :showBtns="true"></vue-json-editor>
        </el-form-item>

        <el-form-item>
          <el-upload
              class="upload-demo"
              action="https://saisitax.oss-cn-zhangjiakou.aliyuncs.com/PutObject/picture/baosi/"
              :on-remove="handleRemove"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :file-list="this.form.pic"
              list-type="picture">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </el-form-item>


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false" @click.native.prevent="handleCancel">取 消</el-button>
        <template v-if="!this.isEdit">
          <el-button type="primary" @click.native.prevent="handleAdd">添加</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click.native.prevent="handleEdit">编辑</el-button>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as _ from 'lodash';
import VueJsonEditor from '@/components/VueJsonEditor'
import {getSaleEntity, getActiveStateTagInfo} from "@/utils";
import SaleEntity from "@/views/components/SaleEntity.vue";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {Pagination, SaleEntity, VueJsonEditor},
  data() {
    return {
      activeName: 'tab_1',
      form: {},
      List: [],
      formVisible: false,
      formQuery: {
        baosiName: "",
        baosiId: ""
      },
      isEdit: false,
      getActiveStateTagInfo,
    }
  },
  mounted() {
    this.resetForm();
  },
  methods: {
    getSaleEntity,

    query: function (offset, limit) {
      let params = {
        baosiId: this.formQuery.baosiId,
        baosiName: this.formQuery.baosiName,
        limit,
        offset
      }
      this.$axios.post('/baosi/list', params).then(res => {
        this.$message.info('查询保司成功');
        this.List = res.baoSiList;
        if(offset === 0) {
          this.$refs.pagination.reset(res.count);
        } else {
          this.$refs.pagination.setTotal(res.count);
        }
        this.logining = false;
      }).catch(res => {
        this.logining = false;
      })
    },

    onPageChange: function (pageSize, currentPage) {
      this.query((currentPage - 1) * pageSize, pageSize);
    },

    handleQuery: function (row, val) {
      this.query(0, this.$refs.pagination.getSize());
    },

    handleEditVisble: function (index, row) {
      this.form = _.merge({}, row);
      this.formVisible = true;
      this.isEdit = true;
    },

    handleEdit: function (index, row) {
      const params = _.merge({}, this.form, {
        baosiId: this.form._id,
      });
      this.$axios.post('/baosi/update', params).then(res => {
        this.$message.info('修改保司成功');
      }).catch(res => {
      })
      this.formVisible = false;
      this.resetform();
    },

    handleDelete: function (index, row) {
      this.$confirm("确认删除保险公司？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "red"
      }).then(() => {
        let params = {
          baosiId: row._id,
        }
        this.$axios.post('/baosi/delete', params).then(res => {
          this.$message.info('删除保司成功');
        }).catch(res => {
          this.logining = false;
        })

      }).catch(() => {
      })
    },

    handleAdd: function () {
      const params = _.merge({}, this.form, {
        baosiId: this.form._id,
      });
      this.$axios.post('/baosi/create', params).then(res => {
        this.$message.info('上传保司成功');
      }).catch(res => {
        this.logining = false;
      })
      this.formVisible = false;
      this.resetForm();
    },

    //上传照片
    handleRemove(_, fileList) {
      fileList.forEach((file) => {
        this.form.pic.push({
          name: file.name,
          url: file.url.split('blob:')[1]
        })
      })
    },
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleSuccess(res, file) {
      this.form.pic.push({
        name: file.name,
        url: file.url.split('blob:')[1]
      });
    },

    handleCancel() {
      this.formVisible = false;
      this.resetForm();
    },

    resetForm() {
      this.form = {
        name: "",
        info: "",
        phone: "",
        pic: [],
        extra: {},
        _id: "",
        realId: "",
        saleEntity: ""
      }
    },

    handleChangeState(state, row) {
      let params = {
        baosiId: row._id,
        state
      };
      this.$axios.post('/baosi/update', params).then(res => {
        this.$message.info('更新保司成功');
      }).catch(res => {
      })
    },
  },

  watch: {},

  created() {
  },

}
</script>

<style scoped>
</style>
